import { createStore } from "core/redux";
import { history } from "core/router";
import { combineReducers } from "redux";
import { combineEpics } from "redux-observable";

import { epic as userEpic, reducer as userReducer } from "./user";

import insidersReducer from "./insiders/reducer";
import bookingReducer from "./booking/reducer";
import feedbackReducer from "./feedback/reducer";
import paymentReducer from "./payment/reducer";
import callingReducer from "./calling/reducer";
import referralReducer from "./referral/reducer";

import bookingEpic from "./booking/epic";
import callingEpic from "./calling/epic";
import paymentEpic from "./payment/epic";
import feedbackEpic from "./feedback/epic";
import referralEpic from "./referral/epic";
import insidersEpic from "./insiders/epic";

const reducer = combineReducers({
  user: userReducer,
  insiders: insidersReducer,
  booking: bookingReducer,
  feedback: feedbackReducer,
  payment: paymentReducer,
  calling: callingReducer,
  referral: referralReducer
});

const epic = combineEpics(
  userEpic,
  bookingEpic,
  paymentEpic,
  feedbackEpic,
  callingEpic,
  referralEpic,
  insidersEpic
);
const { store, persistor } = createStore(reducer, epic, history);

export { store, persistor };



// WEBPACK FOOTER //
// ./src/modules/index.js